import { share, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { ApiService } from '../../shared/services/index';

import * as _ from 'lodash';
import { CurrencyModel } from '../models';
import { ApiMode } from '../../utils/enums';
import { OfflineApiService } from './offlineApi.service';
import { AppConstants } from '../../utils/appConstants.class';
import { LogService } from './log.service';

@Injectable({
  providedIn: 'root'
})
export class CurrencyService {
  private currencies: any = [];
  private currencyLoader: Observable<any>;
  public loaded = false;

  constructor(protected apiService: ApiService, private offlineApi: OfflineApiService, private logService: LogService) {
    this.loadCurrencyData();
  }

  public loadCurrencyData() {
    const self = this;
    this.currencyLoader = this.loadCurrencies().pipe(
      map((res: any) => {
        this.currencyLoader = null;
        this.loaded = true;
        const currencies = res;

        _.map(currencies, (el) => {
          self.currencies.push(new CurrencyModel(el.Label, el.Value));
        });

        return this.currencies;
      }),
      share()
    );
    this.currencyLoader.subscribe(
      (data: any) => {},
      (err: any) => this.logService.logError(err, 'Currency loading error')
    );
  }

  private loadCurrencies() {
    const url = '/currencies';
    return this.offlineApi.getWithMode(url, ApiMode.Offline, AppConstants.INDEXEDDB_TABLES.currencies);
  }

  getValue(value: any, array: any): string {
    const obj = _.find(array, ['value', value]);
    return obj ? obj.label : '';
  }

  public getCurrencies(): Observable<any> {
    if (this.currencyLoader) {
      return this.currencyLoader;
    }
    return new BehaviorSubject(this.currencies).asObservable();
  }
}
